import React from 'react';
import { useLocation } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';

function WorkspaceAccessPendingPage() {
  const location = useLocation();

  return (
    <MainLayout withSidebar activePath={location.pathname}>
      <main className="flex min-h-[calc(100vh-12rem)] flex-1 items-center justify-center px-4 pb-10 sm:px-6">
        <section className="glass-panel w-full max-w-2xl p-6 text-center sm:p-10">
          <h1 className="text-xl font-semibold text-slate-900 sm:text-2xl">
            Workspace access is being configured
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-slate-600">
            Your account is active, but no workspace modules are assigned yet.
            Contact your administrator to grant the permissions you need.
          </p>
          <div className="mx-auto mt-5 max-w-xl rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs font-medium text-amber-800">
            Once permissions are assigned, your workspace menu will appear automatically.
          </div>
        </section>
      </main>
    </MainLayout>
  );
}

export default WorkspaceAccessPendingPage;
